var React = require('react');

function FooterHomeLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001H1L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001H20V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001Z","fill":"white","fillOpacity":"0.8","key":0}),React.createElement("path",{"d":"M15.9606 9.33398H13.667L12.0039 11.6892L10.333 9.33398H8.03941L10.8532 13.3065L8 17.334H10.2936L12.0039 14.9238L13.7143 17.334H16L13.1468 13.3065L15.9606 9.33398Z","fill":"white","fillOpacity":"0.8","key":1})]);
}

FooterHomeLogo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FooterHomeLogo;

FooterHomeLogo.default = FooterHomeLogo;
